import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import accordion from './helpers/accordion';
import activeToggle from './helpers/activeAccordion';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { headerJs } from './header';
import { lenis } from './plugins/initLenis';

headerJs()
// Tip tool for arrays info icons
tippy('.infoIcon', {
    content(reference) {
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        return template.innerHTML;
    },
    allowHTML: true,
    placement: 'top-start',
});

// Table rows toggler button

const arrayRowsToggler = document.querySelector('#toggleRowsButton');
const tableRows = document.querySelectorAll('.ctableRows')
let rowsExpanded = false;

arrayRowsToggler && arrayRowsToggler.addEventListener("click", function () {
    rowsExpanded = !rowsExpanded
    this.setAttribute("aria-expanded", rowsExpanded);
    if (rowsExpanded) {
        tableRows.forEach(elem => {
            elem.classList.remove('[&:nth-child(n_+_7)]:hidden')
        })
        this.querySelector('span.material-symbols-outlined').classList.add('-scale-y-100')
        this.querySelector('span.btnTxt').innerHTML = "Δείτε λιγότερα"
    } else {
        tableRows.forEach(elem => {
            elem.classList.add('[&:nth-child(n_+_7)]:hidden')
        })
        this.querySelector('span.material-symbols-outlined').classList.remove('-scale-y-100')
        this.querySelector('span.btnTxt').innerHTML = "Δείτε περισσότερα"
        setTimeout(() => lenis.scrollTo('#tableScroller', {
            offset: -200,
            duration: 1
        }), 50)

    }
})




// faqs accordions
const accordions = document.querySelectorAll('[data-js="accordion"]')

setTimeout(() => {
    accordions.forEach((elem, index) => {
        accordion(elem, true);
        const accordionButton = elem.querySelector(".accordion-button")
    });
    activeToggle(accordions[0]);
    accordions[0].querySelector('[data-js="accordion-toggler"]').setAttribute('aria-expanded', "true")

}, 100)

// Subscription plans buttons

const planButtons = document.querySelectorAll('.subscriptions button');

function moveSwitch(width, left) {
    const switchBack = document.querySelector(".switch");
    switchBack.style.width = `${width}px`;
    switchBack.style.left = `${left}px`
}
setTimeout(() => moveSwitch(planButtons[0].offsetWidth, planButtons[0].offsetLeft), 500)




var plansSwiper = new Swiper(".plansSwiper", {
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: { crossFade: true },
    noSwiping: false,
    allowTouchMove: false,
    noSwipingClass: ".plansSwiper"
});
var subscriptionsSwiper = new Swiper(".subscriptionsSwiper", {
    slidesPerView: 1,
    spaceBetween: -41,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    breakpoints: {
        767: {
            slidesPerView: 3,
            spaceBetween: 32
        },
        1280: {
            slidesPerView: 4,
            spaceBetween: 32
        },
    }
})

planButtons.forEach((elem, index) => {
    elem.addEventListener('click', function () {
        // console.log(this.offsetLeft, this.offsetWidth)
        moveSwitch(this.offsetWidth, this.offsetLeft)
        plansSwiper.slideTo(index)
    })
})